import PropTypes from 'prop-types';
import { ConfirmationModal } from '../../modals';

/**
 * Component to display a modal asking for confirmation before canceling a demand.
 * This modal will appear when the user requests to cancel a demand and requires confirmation.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.open - Determines if the modal should be visible.
 * @param {Function} props.handleClose - Function to call when closing the modal without confirming.
 * @param {Function} props.handleConfirm - Function to call when the cancellation is confirmed.
 * @returns {JSX.Element|null} The modal component or null if it should not be displayed.
 */
const CancelDemandModal = (props) => {
  const { open, handleClose, handleConfirm } = props;

  if (!open) {
    return;
  }

  return (
    <ConfirmationModal
      data-cy="modal-confirm-demand-cancellation"
      title="Annulation d'une demande"
      message="Êtes-vous sur de vouloir annuler cette demande ?"
      cancelText="Conserver la demande"
      criticalActionText="Annuler la demande"
      open={open}
      variant="critical"
      handleCancel={handleClose}
      handleClose={handleClose}
      handleCriticalAction={handleConfirm}
    />
  );
};

CancelDemandModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired
};

export default CancelDemandModal;
